import React from 'react';
import CRUDSection from '../CRUDSection';

function MostReadArticles() {
  const config = {
    title: 'Article',
    tableColumns: ['Image', 'Title', 'Abstract', 'Reads', 'Link', 'Actions'],
    renderForm: (formData, handleInputChange, handleImageChange, isEditing) => (
      <>
        <div className="form-grid">
          <div className="form-group">
            <label>Title *</label>
            <input
              type="text"
              name="title"
              value={formData.title || ''}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>No. of Reads *</label>
            <input
              type="number"
              name="reads"
              min="0"
              value={formData.reads || ''}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className="form-grid">
          <div className="form-group">
            <label>Link (optional)</label>
            <input
              type="url"
              name="link"
              value={formData.link || ''}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="form-grid full">
          <div className="form-group">
            <label>Abstract *</label>
            <textarea
              name="abstract"
              value={formData.abstract || ''}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Image *</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required={!isEditing}
            />
            <small>Leave blank to keep existing image when updating</small>
          </div>
        </div>
      </>
    ),
    renderRow: (item, handleEdit, handleDelete) => (
      <>
        <td>
          <img src={item.imageUrl} alt={item.title} />
        </td>
        <td>{item.title}</td>
        <td>{item.abstract}</td>
        <td>{item.reads}</td>
        <td>
          {item.link ? (
            <a href={item.link} target="_blank" rel="noopener noreferrer">
              View
            </a>
          ) : (
            'N/A'
          )}
        </td>
        <td className="table-actions">
          <button className="btn-edit" onClick={() => handleEdit(item)}>
            Edit
          </button>
          <button className="btn-delete" onClick={() => handleDelete(item.id)}>
            Delete
          </button>
        </td>
      </>
    )
  };

  return <CRUDSection category="mostread" config={config} />;
}

export default MostReadArticles;
